import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"
import SectionModel from "../../model/SectionModel";
import {ISectionMenuL1, ISectionMenuL2} from "../../interface/ISection";
import {HelperSvg} from "../../helper/HelperSvg";

interface ISectionLineData {
    code1: string
    code2: string | null
    name: string
}

export class ComCatalogSectionStore {
    private rootStore: RootStore | undefined;

    public arSection = [];
    public arSectionDATA: ISectionLineData[] = [];
    public error: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init(clientId: number) {
       /* let getAllSection = localStorage.getItem("getAllSection");
        // @ts-ignore
        if (getAllSection !== undefined && getAllSection?.length > 0) {
            if (getAllSection != null) {
                this.setData(JSON.parse(getAllSection));
            }
        } else {
            this.initMain(clientId);
        }*/
        this.initMain(clientId);
    }

    initMain(clientId: number) {
        let token = localStorage.getItem("token");
        if (token && !SectionModel.q.token) {
            SectionModel.q.setBaseUrl();
            SectionModel.q.reload();
        }
        SectionModel.getAllSection(clientId, this.setData, this.setError);
    }


    @action
    setData = (result: any) => {
        if (Array.isArray(result?.data?.rows)) {
            localStorage.setItem("getAllSection", JSON.stringify(result));
            let noIndex: number[] = [];
            result.data.rows.map((item: ISectionMenuL1, index: number) => {
                item.svgSectionLeft = HelperSvg.getSidebarLeft(item.ex_id);
                item.svgSectionTop = HelperSvg.getMenuTop(item.ex_id);
                this.arSectionDATA.push({
                    code1: item.code,
                    code2: null,
                    name: item.name
                });
                item.SectionChild?.map((item2: ISectionMenuL2) => {
                    this.arSectionDATA.push({
                        code1: item.code,
                        code2: item2.code,
                        name: item2.name
                    });
                    return item2;
                });
                if (!item.SectionChild?.length) {
                    noIndex.push(index);
                }
                return item;
            });

           if (noIndex.length) {
                noIndex.forEach((index: number) => {
                    delete result.data.rows[index];
                });
               result.data.rows=result.data.rows.filter((item:any)=>item);
            }


            this.arSection = result.data.rows;
        }
    }

    @action
    setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }

    @action
    getSectionFindInDATA = (code1: string | null, code2: string | null) => {
        for (let item of this.arSectionDATA) {
            if (code1 === item.code1 && code2 === item.code2) {
                return item;
            }
        }
        return null;
    }


}